import { toExcelAmount, toExcelDate } from 'components/xlsx/excelCells';
import { ClassifierData } from 'types/classifiers';
import { LinkedInvoiceMinDto, PrepaymentListItem } from 'types/prepayments';
import { getClassifierText, t } from 'utils/getTranslations';
import { toBigFixed } from 'utils/numberUtil';

// Mirrors the linked-invoices cell: the consuming invoice's number followed by its gross amount.
// The cell's type/status chips are dropped — the amount is what a prepayment is reconciled against.
const linkedInvoicesColumn = (linkedInvoices: LinkedInvoiceMinDto[] | null): string =>
    (linkedInvoices ?? []).map((linked) => `${linked.invoiceNumber} (${toBigFixed(linked.grossAmount)})`).join('; ');

export const mapPrepaymentsToCSVFormat = (
    prepayments: PrepaymentListItem[],
    classifiers: Record<string, ClassifierData>
) => {
    return prepayments?.map((prepayment) => ({
        [t('prepayments.export.invoice-number')]: prepayment.invoiceNumber,
        [t('prepayments.export.status')]: getClassifierText(
            classifiers['INVOICE_STATUS_TYPE'],
            prepayment.invoiceStatusTypeCode
        ),
        [t('prepayments.export.client')]: (prepayment.invoiceMattersClientParties ?? [])
            .map(({ name }) => name)
            .join(', '),
        [t('prepayments.export.payer')]: prepayment.clientParty?.name ?? '',
        [t('prepayments.export.cases')]: (prepayment.matters ?? []).map(({ fullName }) => fullName).join('; '),
        [t('prepayments.export.invoice-date')]: toExcelDate(prepayment.invoiceDate),
        [t('prepayments.export.due-date')]: toExcelDate(prepayment.dueDate),
        [t('prepayments.export.paid-on')]: toExcelDate(prepayment.paidOnDate),
        [t('prepayments.export.linked-invoices')]: linkedInvoicesColumn(prepayment.linkedInvoices),
        [t('prepayments.export.payment-currency')]: prepayment.paymentCurrencyTypeCode,
        [t('prepayments.export.vat-total')]: toExcelAmount(prepayment.vatTotal),
        [t('prepayments.export.gross-total')]: toExcelAmount(prepayment.grossTotal),
        [t('prepayments.export.used-amount')]: toExcelAmount(prepayment.usedAmount),
        [t('prepayments.export.remaining-amount')]: toExcelAmount(prepayment.remainingAmount),
        [t('prepayments.export.base-currency')]: prepayment.baseCurrencyTypeCode,
        [t('prepayments.export.vat-total-base')]: toExcelAmount(prepayment.vatTotalBaseCurrency),
        [t('prepayments.export.net-total-base')]: toExcelAmount(prepayment.netTotalBaseCurrency),
        [t('prepayments.export.gross-total-base')]: toExcelAmount(prepayment.grossTotalBaseCurrency),
        [t('prepayments.export.used-amount-base')]: toExcelAmount(prepayment.usedAmountBaseCurrency),
        [t('prepayments.export.remaining-amount-base')]: toExcelAmount(prepayment.remainingAmountBaseCurrency),
        [t('prepayments.export.retainer-balance')]: toExcelAmount(prepayment.retainerBalance),
    }));
};
